/**
 * Review Interactions Module
 * Handles review like/dislike/report functionality
 */

export const reviewInteractions = {
    // Initialize review interactions
    initializeReviewInteractions() {
        this.setupReviewEventListeners();
    },

    // Setup review event listeners
    setupReviewEventListeners() {
        // Use event delegation to handle dynamic review elements
        document.addEventListener('click', (e) => {
            // Handle like/dislike buttons
            if (e.target.closest('.review-like-btn') || e.target.closest('.review-dislike-btn')) {
                const button = e.target.closest('.review-like-btn') || e.target.closest('.review-dislike-btn');
                this.handleReviewFeedback(button);
            }

            // Handle report button
            if (e.target.closest('.review-report-btn')) {
                const button = e.target.closest('.review-report-btn');
                this.handleReviewReport(button);
            }
        });
    },

    // Handle review feedback (like/dislike)
    async handleReviewFeedback(button) {
        const reviewId = button.dataset.reviewId;
        const likeValue = button.dataset.like;
        const url = button.dataset.url;

        if (!url || !reviewId) return;

        button.style.opacity = '0.6';
        button.style.pointerEvents = 'none';

        try {
            const payload = { review_id: reviewId, like: likeValue === '1' };
            let data;

            if (window.apiRequest) {
                data = await window.apiRequest(url, {
                    method: 'POST',
                    body: JSON.stringify(payload),
                });
            } else {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'X-CSRF-TOKEN': this.getCsrfToken(),
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) {
                    try {
                        data = await response.json();
                    } catch (_) {
                        data = {};
                    }
                    if (this.handleVerificationRequired(data)) {
                        return;
                    }
                    this.showMessage('error', data.message || 'خطا در ثبت نظر');
                    return;
                }
                data = await response.json();
            }

            if (data && data.like_count !== undefined && data.dislike_count !== undefined) {
                this.updateReviewCounts(button, data);
            }
        } catch (error) {
            console.error('Error:', error);
            const data = error?.data || {};

            if (this.handleVerificationRequired(data)) {
                return;
            }
            if (error?.status === 401) {
                // Guest — prompt login instead of a bare error (issue #7).
                sessionStorage.setItem('intendedUrl', window.location.href);
                window.dispatchEvent(new CustomEvent('open-modal', { detail: { id: 'auth-modal' } }));
                this.showMessage('error', 'برای ثبت نظر ابتدا وارد حساب خود شوید.');
                return;
            }
            this.showMessage('error', data.message || 'خطا در ثبت نظر');
        } finally {
            button.style.opacity = '1';
            button.style.pointerEvents = 'auto';
        }
    },

    // Update review counts
    updateReviewCounts(button, data) {
        const card = button.closest('.review-item');
        if (!card) return;
        const likeCountSpan = card.querySelector('.like-count');
        const dislikeCountSpan = card.querySelector('.dislike-count');

        if (likeCountSpan && data.like_count !== undefined) likeCountSpan.textContent = data.like_count;
        if (dislikeCountSpan && data.dislike_count !== undefined) dislikeCountSpan.textContent = data.dislike_count;
    },

    // Handle review report — opens the shared report-reason modal
    handleReviewReport(button) {
        const reviewId = button.dataset.reviewId;
        if (!reviewId) return;

        if (window.Livewire && typeof window.Livewire.dispatch === 'function') {
            window.Livewire.dispatch('openModal', {
                component: 'report-form',
                arguments: {
                    reportableType: 'university_reviews',
                    reportableId: parseInt(reviewId, 10),
                },
            });
        } else {
            this.showMessage('error', 'خطا در باز کردن فرم گزارش. لطفاً صفحه را تازه‌سازی کنید.');
        }
    },

    // Open the shared verification modal when the server requires email/phone verification
    handleVerificationRequired(data) {
        if (data && data.verification_required &&
            window.VerificationHandler &&
            typeof window.VerificationHandler.init === 'function' &&
            typeof window.VerificationHandler.showModal === 'function') {
            window.VerificationHandler.init(
                data.verification_type || 'email',
                data.missing_verifications || [],
                { email: data.user_email || '', phone: data.user_phone || '' }
            );
            window.VerificationHandler.showModal();
            return true;
        }
        return false;
    }
};
